import Icon from '../components/Icon.vue'

Icon.register({
  'glass-martini-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.1 57.6l-214.1 214v192.4h56c22.1 0 40 17.9 40 40 0 4.4-3.6 8-8 8h-240c-4.4 0-8-3.6-8-8 0-22.1 17.9-40 40-40h56v-192.4l-214.1-214c-21.3-21.3-6.2-57.6 23.8-57.6h444.4c30 0 45.1 36.3 23.8 57.6zM443.8 48h-375.5l48 48h279.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glass-martini-alt.js
// module id = 1384
// module chunks = 0